import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["dropdown"]

    connect() {
        // Handle clicks outside the dropdown
        this.clickOutsideHandler = this.handleClickOutside.bind(this)
        document.addEventListener("click", this.clickOutsideHandler)
    }

    disconnect() {
        document.removeEventListener("click", this.clickOutsideHandler)
    }

    async toggle(event) {
        event.stopPropagation()
        this.dropdownTarget.classList.toggle("hidden")

        // If opening the dropdown, mark all as read
        if (!this.dropdownTarget.classList.contains("hidden")) {
            await this.markAllAsRead()
        }
    }

    async markAllAsRead() {
        const namespace = document.querySelector('body').getAttribute('namespace')
        if (!namespace) return

        try {
            await fetch(`/${namespace}/notifications/mark_all_as_read`, {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                },
            })

            // Update UI
            this.element.querySelectorAll('[data-notification-id]').forEach(el => {
                el.dataset.read = "true"
                el.classList.remove("bg-blue-50", "dark:bg-blue-900/20")
            })

            // Hide unread count badge
            const badge = this.element.querySelector('.bg-red-500')
            if (badge) badge.remove()
        } catch (error) {
            console.error('Error marking all notifications as read:', error)
        }
    }

    handleClickOutside(event) {
        if (!this.element.contains(event.target) && !this.dropdownTarget.classList.contains("hidden")) {
            this.dropdownTarget.classList.add("hidden")
        }
    }
}
